export class PsChecks {

    checkedIds;

    constructor() {
        this.checkedIds = [];
    }

    check(id) {
        this.checkedIds = this.isChecked(id)
            ? this.checkedIds.filter(itemId => itemId !== id)
            : [...this.checkedIds, id];

        return this.checkedIds;
    }

    checkPage(currentPageIds) {
        const pageChecked = this.isPageChecked(currentPageIds);
        if ( pageChecked ) this.uncheckAllPage(currentPageIds);
        else this.checkAllPage(currentPageIds);

        return this.checkedIds;
    }

    isPageChecked(currentPageIds) {
        return this.checkedIds.length === 0
            ? false
            : currentPageIds.every(id => this.checkedIds.includes(id));
    }

    checkAllPage(currentPageIds) {
        this.checkedIds = [...currentPageIds];
    }

    uncheckAllPage(currentPageIds) {
        this.checkedIds = this.checkedIds.filter(id => !currentPageIds.includes(id));
    }

    reset() {
        this.checkedIds = [];
        return this.checkedIds;
    }

    isChecked(id) {
        return this.checkedIds.includes(id);
    }

    getCheckedIds() {
        return this.checkedIds;
    }

    noneSelected() {
        return this.checkedIds.length === 0;
    }

    hasSelected() {
        return !this.noneSelected();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PsChecks.js